const validate = (values) => {
    const errors = {};
    if (!values.username) {
      errors.username = 'El campo de usuario no debe estar vacio';
    }
    if (!values.password) {
      errors.password = 'El campo de contraseña no debe estar vacia';
    }
    
    return errors;
  };
  
  export default validate;